import { useEffect } from 'react'
import { createScrollLock } from './scrollLock'

/** Один счётчик на приложение: замок на body. */
const bodyLock = createScrollLock(() => document.body)

/** Фон не прокручивается, пока компонент на экране (и `active`). */
export function useScrollLock(active = true): void {
  useEffect(() => {
    if (!active) return
    return bodyLock.lock()
  }, [active])
}
